import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const name = 'messageLink';

interface IMessageLinkState {
  linkTargetIds: string[];
}

const initialState: IMessageLinkState = { linkTargetIds: [] };

export const { reducer, actions } = createSlice({
  name,
  initialState,
  reducers: {
    addLinkTargetId: (state, action: PayloadAction<string>) => {
      if (action.payload.trim() === '') return;

      const existing = state.linkTargetIds.some((m) => m === action.payload);
      if (!existing) {
        state.linkTargetIds.push(action.payload);
      }
    },
    deleteLinkTargetId: (state, action: PayloadAction<string>) => {
      if (action.payload.trim() === '') return;

      state.linkTargetIds = state.linkTargetIds.filter((m) => m !== action.payload);
    },
  },
});
